/* global graphql */
import Link from 'gatsby-link'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import ReactHtmlParser from 'react-html-parser'
import Header from '../components/header-new'
import Footer from '../components/footer-new'

class BlogPost extends Component {
  constructor (props) {
    super(props)

    let isMobile = false
    const parallaxMove = {
      start: 900,
      end: 0
    }

    this.state = {
      blogPostData: this.props.data.drupalBlog,
      blogContent: '',
      isMobile,
      parallaxMove
    }
  }

  componentWillMount () {
    let isMobile = false
    if (typeof window !== 'undefined') {
      isMobile = window.innerWidth < 480
    }

    const parallaxMove = {
      start: isMobile ? 300 : 900,
      end: isMobile ? -150 : 0
    }

    this.setState({
      isMobile,
      parallaxMove
    })
  }

  componentDidMount () {
    const GATSBY_CMS_API_URL = process.env.GATSBY_CMS_API_URL
    let blogContentText = this.props.data.drupalBlog.body.value
    /* Replace relative path in img tag src attribute with absolute path
     * using the CMS API URL */
    blogContentText = blogContentText.replace(
      /<img ([^>]*)src=["|'](\/sites\/default\/files\/inline-images\/[^"]*)["|']([^>]*)>/gm,
      `<img $1src="${GATSBY_CMS_API_URL}$2"$3>`
    )
    const blogContent = ReactHtmlParser(blogContentText)

    this.setState({
      blogContent
    })
  }

  render () {
    const { title, date, category, author } = this.state.blogPostData
    const authorList = author.map((authorname, ind) => (<div key={ind}>{authorname.entity.title}</div>))

    return (
      <div className='blogpost'>
        <Header theme='dark' />
        <Helmet title={`Updates: ${title} - ATTN:`} />
        <div className='dark blogpost--hero'>
          <h1>{title}</h1>
          <div className='blogpost--details'>
            <div className='category'>{category.entity.title} &#8226; </div>
            <div className='date'>{date.value} &#8226;</div>
            <div className='author'>
              {authorList}
            </div>
          </div>
          <div className='floating-circle-blog-lg' />
          <div className='floating-circle-blog-sm' />
        </div>
        <div className='blog-plx-wrapper'>
          <div className='pink-rect' />
        </div>
        <div className='wrapper-max-width'>
          <div className='blogpost--page'>
            <div className='blogpost--content'>
              {this.state.blogContent}
            </div>
            <Link className='blogpost--return' to='/updates'>
              &#8592; Return to updates
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

BlogPost.propTypes = {
  data: PropTypes.object
}

export const query = graphql`
  query BlogPostQuery ($originalSlug: String) {
    drupalBlog(url : { path: { eq: $originalSlug } }) {
      id
      author {
        entity {
          name
          title
        }
      }
      body {
        value
        summary
      }
      category {
        entity {
          tid
          uuid
          changed
          type
          title
          weight
        }
      }
      created
      date {
        value(formatString: "MMMM Do, YYYY")
      }
      url {
        routed
        path
      }
      title
    }
  }
`

export default BlogPost



// WEBPACK FOOTER //
// ./src/layouts/blog-post.js